class ListingComponent extends HTMLElement {
  constructor() {
    super();

    this.filterIds = ['FiltersForm', 'FiltersFormDrawer'];

    this.sectionId = this.dataset.sectionId;
    this.cache = [];

    this.appendNext = false;

    this.initialSearchParams = window.location.search.slice(1);
    this.currentSearchParams = window.location.search.slice(1);
    if(this.currentSearchParams) this.buildSizeFilters();

    this.hasFilters = false;

    this.filtersApply = this.querySelector('.filters__apply');

    this.forms = this.querySelectorAll('listing-form form');

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 600);

    if (this.filtersApply) {
      this.filtersApply.addEventListener(
        'click',
        this.onFiltersApply.bind(this)
      );
    }

    this.forms.forEach((form) => {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));

      if (this.filterIds.indexOf(form.id) > -1) {
        this.hasFilters = true;
      }
    });

    window.addEventListener('popstate', (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : this.initialSearchParams;

      if (searchParams === this.currentSearchParams) return;

      this.renderPage(searchParams, null, false);
    });

    let params = new URLSearchParams(this.currentSearchParams);
    let sortOn = params.get('sort_on');

    if(sortOn == 'year') {
      this.dropdown = this.querySelector('select[name="sort_by"]')
      this.dropdown.value = 'year_sort'
    }

    this.bindInputs();
  }

  bindInputs() {
    this.querySelectorAll(`[name="price_range"]:checked`).forEach((input) => {
      input.addEventListener('click', (e) => {
        e.target.checked = false;
        this.onSubmitHandler(e);
      });
    });

    this.searchFilters = this.querySelectorAll('.field__input');

    this.searchFilters.forEach((input) => {
      input.addEventListener('input', (e) => {
        const searchValue = input.value.trim().toLowerCase();

        const subMenu = input.closest('.mobile-facets__submenu');
        const items = subMenu.querySelectorAll('.mobile-facets__item');

        items.forEach((item) => {
          if (
            searchValue == '' ||
            item.dataset.label.toLowerCase().indexOf(searchValue) > -1
          ) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      });
    });
  }

  onSubmitHandler(event) {
    if (event) {
      event.preventDefault();
    }

    if (event.target.id.indexOf('FilterSearch') > -1) {
      return;
    }

    const forms = [];

    this.forms.forEach((form) => {
      if (this.filterIds.indexOf(form.id) > -1) {
        if (form.contains(event.target)) {
          forms.push(this.createSearchParams(form));
        }
      } else {
        forms.push(this.createSearchParams(form));
      }
    });

    this.renderPage(forms.join('&'), event);
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    const priceRangeEntries = Array.from(formData.entries()).filter(([key]) =>
      key.startsWith('price_range')
    );

    if (priceRangeEntries.length > 0) {
      var priceMin = 99999999;
      var priceMax = 0;

      priceRangeEntries.forEach(([key, value]) => {
        const [min, max] = value.split('-');

        if (min < priceMin) {
          priceMin = min;
        }

        if (max > priceMax) {
          priceMax = max;
        }
      });

      formData.append(`filter.v.price.gte`, (priceMin / 100).toFixed(2));

      formData.append(`filter.v.price.lte`, (priceMax / 100).toFixed(2));

      formData.delete('price_range');
    }

    return new URLSearchParams(formData).toString();
  }

  renderPage(searchParams, event, updateURLHash = true) {

    let params = new URLSearchParams(searchParams);
    let sortBy = params.get('sort_by');

    gtag("event", "collection_sort", {
      'sort_by': sortBy
    });
    
    if (sortBy == 'stars') {
      this.classList.add('loading');
      window.location.href = `${window.location.pathname}?${searchParams}`;
      return;
    }
    else if (sortBy == 'year_sort') {
      this.classList.add('loading');
      window.location.href = `${window.location.pathname}?sort_by=created-descending&sort_on=year`;
      return;
    }
    else {
      this.currentSearchParams = searchParams;
    }

    this.classList.add('loading');

    const url = `${window.location.pathname}?section_id=${this.sectionId}&${this.currentSearchParams}`;

    this.cache.some((element) => element.url === url)
      ? this.renderSectionFromCache(url, event)
      : this.renderSectionFromFetch(url, event);

    if (updateURLHash) this.updateURLHash(this.currentSearchParams);
  }

  onFiltersApply(e) {
    e.preventDefault();

    this.forms.forEach((form) => {
      const drawer = form.closest('menu-drawer');

      if (drawer) {
        drawer.closeMenuDrawer(form);
      }
    });
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        this.buildPage(url, html, event);
      });
  }

  renderSectionFromCache(url, event) {
    const html = this.cache.find((element) => element.url === url).html;

    this.buildPage(url, html, event);
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  buildPage(url, html, event) {
    this.cache.push({ html, url });

    if (this.hasFilters) {
      this.buildFilters(html, event);
    }

    this.buildProducts(html, event);
    this.classList.remove('loading');
    this.buildSizeFilters();
  }

  buildFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    this.filterIds.forEach((filterId) => {
      const filterFromFetch = parsedHTML.getElementById(filterId);
      const filterFromDom = document.getElementById(filterId);

      if (!filterFromFetch) return;
      if (!filterFromDom) return;

      const openFilters = [];

      filterFromDom.querySelectorAll('.filters__details').forEach((detail) => {
        if (detail.open) {
          openFilters.push(detail.id);
        }
      });

      filterFromFetch
        .querySelectorAll('.filters__details')
        .forEach((detail) => {
          if (openFilters.indexOf(detail.id) > -1) {
            detail.open = true;
          } else {
            detail.open = false;
          }
        });

      filterFromDom.innerHTML = filterFromFetch.innerHTML;
    });

    if (window.innerWidth >= 750) {
      if (event) {
        if (event.target.id) {
          const selectedInput = document.querySelector(`#${event.target.id}`);

          if (selectedInput) {
            setTimeout(() => {
              selectedInput.focus();
            }, 100);
          }
        }
      }
    }

    this.bindInputs();
  }

  buildSizeFilters() {
    setTimeout(() => {
      document.querySelectorAll('listing-form .size__filter').forEach((sizeLink) => {
        sizeLink.href += `?${this.currentSearchParams}`;
      });
    }, 100);
  }

  buildProducts(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (this.appendNext) {
      const gridItems = parsedHTML.querySelectorAll('#ProductGrid .grid__item');

      const gridContainer = document.getElementById('ProductGrid');

      gridItems.forEach((item) => {
        gridContainer.appendChild(item);
      });

      document.getElementById('Pagination').innerHTML =
        parsedHTML.getElementById('Pagination').innerHTML;
    } else {
      document.getElementById('ProductGridContainer').innerHTML =
        parsedHTML.getElementById('ProductGridContainer').innerHTML;

      document
        .getElementById('ProductGridContainer')
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.remove('scroll-trigger');
          element.classList.remove('animate--slide-in');
        });
    }

    this.appendNext = false;
  }

  setAppendNext(value) {
    this.appendNext = value;
  }
}

customElements.define('listing-component', ListingComponent);

class FilterRemove extends HTMLElement {
  constructor() {
    super();

    this.filter = this.dataset.filter;

    this.listing = this.closest('listing-component');

    this.addEventListener('click', this.onRemove.bind(this));
  }

  onRemove(e) {
    e.preventDefault();

    if (this.filter == 'filter.v.price') {
      this.listing.querySelectorAll(`[name="price_range"]`).forEach((input) => {
        input.checked = false;
      });
    } else {
      this.listing
        .querySelectorAll(`[name="${this.dataset.filter}"]`)
        .forEach((input) => {
          input.checked = false;
        });
    }

    this.listing.onSubmitHandler(e);
  }
}

customElements.define('filter-remove', FilterRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.params = this.dataset.params;

    this.listing = this.closest('listing-component');

    this.button = this.querySelector('.pagination__more');

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.listing.setAppendNext(true);
    this.listing.renderPage(this.params, null, false);
  }
}

customElements.define('load-more', LoadMore);
